import React, { CSSProperties, Dispatch, SetStateAction, useEffect } from 'react';
import { showButtonStyles, showContainerStyles, showTextStyles } from '../../styles/style';
import { Button, Divider } from 'antd';

export interface DataItem {
  label: string;
  key: string;
  otherKeys?: string;
}
interface Props {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  name: string;
  fields: DataItem[];
  data: any;
  listItemStyles?: CSSProperties;
}
const Details = ({ show, setShow, name, fields, data, listItemStyles }: Props) => {
  // Helper function to get nested property value using dot notation
  const getNestedValue = (obj: any, path: string | undefined): any => {
    if (!path || !obj) return undefined;

    // If path contains dots, traverse the object
    if (path.includes('.')) {
      return path.split('.').reduce((current, prop) => current?.[prop], obj);
    }

    // Otherwise, access directly
    return obj[path];
  };

  // TODO: get rid of these lines
  useEffect(() => {
    if (data === undefined || data === null) {
      setShow(false);
    }
  }, [data, setShow]);

  if (data === undefined || data === null) {
    return null;
  }

  if (!show) {
    return (
      <div style={showContainerStyles}>
        <Button type='link' style={showButtonStyles} onClick={() => setShow(true)} disabled={false}>
          {`Show ${name} details`}
        </Button>
      </div>
    );
  }
  return (
    <>
      <div style={showContainerStyles}>
        {fields.map(({ label, key, otherKeys }) => (
          <p style={{ ...showTextStyles, ...listItemStyles }} key={`${name}_${key}`}>
            {label}: <span>{getNestedValue(data, key) ?? getNestedValue(data, otherKeys)}</span>
          </p>
        ))}
      </div>
      <Divider style={{ marginTop: '0' }} />
      <div style={showContainerStyles}>
        <Button type='link' style={showButtonStyles} onClick={() => setShow(false)} disabled={false}>
          {`Hide ${name} details`}
        </Button>
      </div>
    </>
  );
};
export default Details;
